import { render, staticRenderFns } from "./g-end.vue?vue&type=template&id=4d935a88&scoped=true&"
import script from "./g-end.vue?vue&type=script&lang=js&"
export * from "./g-end.vue?vue&type=script&lang=js&"
import style0 from "./g-end.vue?vue&type=style&index=0&id=4d935a88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d935a88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType4: require('D:/Project/kpwebsite/PC/components/content/content-type-4.vue').default,ContentType3: require('D:/Project/kpwebsite/PC/components/content/content-type-3.vue').default})
